/**
 *繁体中文语言包
 */
export const LANGUAGE = {
  guanbi: "關閉",
  fanhui: "返回",
  rengong:"人工",
  rgkf: "人工客服",
  fqxdlthh: "發起新的聊天會話",
  tjwt: "提交問題",
  tjcg: "提交成功",
  wtms: "問題描述",
  hfnr: "回复內容",
  tjhf: "提交回复",
  wjhf: "玩家回复",
  sbppxh: "設備品牌型號",
  sbxtbb: "設備系統版本",
  email: "郵箱",
  wjjwt: "未解決問題",
  yjjwt: "已解決問題",
  qsrhfnr: "請輸入回复內容",
  ssgjc: "請輸入搜索關鍵詞",
  faqcjwt: "FAQ常見問題",
  qsrwtms: "請輸入問題描述",
  qmsnyddwt: "請描述您遇到的問題!",
  xuantian: "選填",
  loadling: "加載中...",
  ltjldzljs: "聊天記錄到這裡結束",
  error1: "回复內容不能為空！",
  error2: "回复內容不超過150個字",
  error3: "orderid獲取失敗!",
  error4: "郵箱格式不正確!",
  error5: "獲取數據失敗，請稍後嘗試。如嘗試有問題，請聯繫客服！",
  error6: "目前沒有相關數據，如有疑問聯繫客服!",
  error7: "很抱歉如果沒能解決你的問題，請繼續發送消息!",
  yhxy: "用戶協議",
  yscl: "隱私策略",
  wjfk: "玩家反饋",
  xuanze: "選擇",
  fwq:"服務器",
  yxzh:"角色名稱",
  tishiyu: "諮詢賬號登入，卡頓，黑屏等無法正常進行遊戲相關問題時，請務必留下您的設備信息。提供完善的信息，將有助於我們更加快速的解決您的問題",
  ssjg: "搜索結果",
  kfgzts: "客服工作時間為09:00-00:00 (UTC+8),我們會在工作時間內盡快回复您!",
}



// WEBPACK FOOTER //
// ./src/language/tw.js